<!--
 * @Author: lmy
 * @Date: 2020-05-22 14:13:50
 * @LastEditTime: 2022-01-11 15:14:49
 * @LastEditors: 超级无敌帅气小陈
 * @Description: {
   分页
    layout：表示需要显示的内容，用逗号分隔，布局元素会依次显示
    prev：表示上一页
    next:为下一页
    pager：表示页码列表
    jumper和total，size特殊的布局符号->，->后的元素会靠右显示
    jumper：表示跳页元素
    total：表示显示页码总数
    @current-page: 分页点击事件
    :current-page：第几页
    :page-size： 几条分一页
 }
 * @FilePath: \1-trunk\src\components\basics\pagination.vue
-->
<template>
  <div v-if="total>0">
    <van-pagination
      @change="handleCurrentChange"
      v-model="current"
      :items-per-page="pageSize"
      :total-items="total"
    ></van-pagination>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      current: 0
    };
  },
  created () {
    this.current = this.currentPage
  },
  methods: {
    handleCurrentChange (done) {
      this.$emit('handleCurrentChange', done);
    }
  },
  watch: {},
  computed: {},
  components: {}
};
</script>

<style lang="scss">
.el-pagination__total {
  font-size: 12px!important;
  color: $black;
  letter-spacing: 0;
  float: left;
  padding: 0 15px;
}
.el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  text-align: right;
}
.el-pagination button{
font-size: 14px;
}
.el-pagination span:not([class*=suffix]){
  font-size: 14px;
}
  .el-pagination {
    padding: 40px 0 40px 10px;
  }
</style>
